import { createAsyncAction, createAction } from 'typesafe-actions'
import {
    CalendarSaveResponse,
    CalendarApproveResponse,
    SystemResponse,
    UserInfoResponse
} from 'redux/interfaces'
import { ICalendar, ICreateCalendar, SaveCalendarsRequest } from 'pages/my-calendars/add-calendar'
import { CalendarTypes } from 'shared/api/calendarsApi'

export const loadSystemConfig = createAsyncAction(
    `SYSTEM/LOAD_REQUEST`,
    `SYSTEM/LOAD_SUCCESS`,
    `SYSTEM/LOAD_FAILURE`
)<undefined, SystemResponse, Error>()

export const loadUserInfo = createAsyncAction(
    'USER/LOAD_REQUEST',
    'USER/LOAD_SUCCESS',
    'USER/LOAD_FAILURE'
)<string, UserInfoResponse, Error>()

export const setUserInfo = createAction('USER/SET_USERINFO')<string>()

export const getCalendar = createAsyncAction(
    'CALENDAR/LIST/GET_CALENDAR_REQUEST',
    'CALENDAR/LIST/GET_CALENDAR_SUCCESS',
    'CALENDAR/LIST/GET_CALENDAR_FAILURE',
    'CALENDAR/LIST/GET_CALENDAR_CANCEL'
)<undefined, ICalendar[], Error, undefined>()

export const getCalendarList = createAsyncAction(
    'CALENDAR/LIST/GET_REQUEST',
    'CALENDAR/LIST/GET_SUCCESS',
    'CALENDAR/LIST/GET_FAILURE',
    'CALENDAR/LIST/GET_CANCEL'
)<undefined, ICalendar[], Error, undefined>()

export const setCalendarId = createAction('CALENDAR/SET_CALENDAR_ID')<string>()

export const getCalendarTypes = createAsyncAction(
    'CALENDAR/TYPES/GET_REQUEST',
    'CALENDAR/TYPES/GET_SUCCESS',
    'CALENDAR/TYPES/GET_FAILURE',
    'CALENDAR/TYPES/GET_CANCEL'
)<undefined, CalendarTypes[], Error, undefined>()

export const createCalendar = createAsyncAction(
    'CALENDAR/CREATE_REQUEST',
    'CALENDAR/CREATE_SUCCESS',
    'CALENDAR/CREATE_FAILURE',
    'CALENDAR/CREATE_CANCEL'
)<ICreateCalendar, CalendarApproveResponse, Error, undefined>()

export const saveCalendar = createAsyncAction(
    'CALENDAR/SAVE_REQUEST',
    'CALENDAR/SAVE_SUCCESS',
    'CALENDAR/SAVE_FAILURE',
    'CALENDAR/SAVE_CANCEL'
)<SaveCalendarsRequest, CalendarSaveResponse, undefined, undefined>()

export const approveCalendar = createAsyncAction(
    'CALENDAR/APPROVE_REQUEST',
    'CALENDAR/APPROVE_SUCCESS',
    'CALENDAR/APPROVE_FAILURE',
    'CALENDAR/APPROVE_CANCEL'
)<undefined, CalendarApproveResponse, Error, undefined>()

// удаление календаря
export const deleteCalendar = createAsyncAction(
    'CALENDAR/DELETE_REQUEST',
    'CALENDAR/DELETE_SUCCESS',
    'CALENDAR/DELETE_FAILURE'
)<string | null, undefined, Error>()

// удаление утвержденного календаря
export const deleteSupplierCalendar = createAsyncAction(
    'CALENDAR/DELETE_CALENDAR_REQUEST',
    'CALENDAR/DELETE_CALENDAR_SUCCESS',
    'CALENDAR/DELETE_CALENDAR_FAILURE'
)<string | null, undefined, Error>()

export const getSuppliers = createAsyncAction(
    'SUPLIERS/GET_REQUEST',
    'SUPLIERS/GET_SUCCESS',
    'SUPLIERS/GET_FAILURE'
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
)<string, any, Error>()
